module.exports = __webpack_public_path__ + "static/media/bd.5b4adc1d.svg";